import React from 'react';
export function Footer() {
  return <footer className="bg-nova-bg border-t-2 border-nova-accent pt-16 pb-8" data-id="element-158">
      <div className="max-w-7xl mx-auto px-6" data-id="element-159">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-160">
          {/* Column 1 */}
          <div data-id="element-161">
            <img src="https://cdn.magicpatterns.com/uploads/igjcstjpy9QDbPwmS8aSgJ/logotipo_trasnparente.png" alt="NovaWeb Logo" className="w-[160px] object-contain mb-4" style={{
            filter: 'drop-shadow(0 0 12px rgba(0, 191, 255, 0.35))'
          }} data-id="element-162" />
            <p className="text-nova-text-muted mb-4" data-id="element-163">Agencia de Diseño Web</p>
          </div>

          {/* Column 2 */}
          <div data-id="element-164">
            <h4 className="text-lg font-bold text-nova-text mb-6" data-id="element-165">
              NAVEGACIÓN
            </h4>
            <ul className="space-y-3" data-id="element-166">
              {['Inicio', 'Sobre Nosotros', 'Portafolio', 'Servicios', 'Contacto'].map(item => <li key={item} data-id="element-167">
                  <a href={`#${item.toLowerCase().replace(' ', '-')}`} className="text-nova-text-muted hover:text-nova-accent transition-colors" data-id="element-168">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Column 3 */}
          <div data-id="element-169">
            <h4 className="text-lg font-bold text-nova-text mb-6" data-id="element-170">CONTACTO</h4>
            <ul className="space-y-3 mb-6" data-id="element-171">
              <li className="flex items-start gap-2 text-nova-text-muted" data-id="element-172">
                <span className="text-nova-accent" data-id="element-173">📱</span>
                <span data-id="element-174">
                  WhatsApp:{' '}
                  <a href="https://wa.me/573508108717" target="_blank" rel="noopener noreferrer" className="text-nova-accent hover:underline" data-id="element-175">
                    3508108717
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-2 text-nova-text-muted" data-id="element-176">
                <span className="text-nova-accent" data-id="element-177">✉️</span>
                <span data-id="element-178">
                  Email:{' '}
                  <a href="mailto:contacto@novaweb.com" className="text-nova-accent hover:underline" data-id="element-179">
                    contacto@novaweb.com
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-2 text-nova-text-muted" data-id="element-180">
                <span className="text-nova-accent" data-id="element-181">📍</span>
                <span data-id="element-182">Colombia · Atención 100% online</span>
              </li>
              <li className="flex items-start gap-2 text-nova-text-muted" data-id="element-183">
                <span className="text-nova-accent" data-id="element-184">🕐</span>
                <span data-id="element-185">Lun - Sáb · 8:00 a.m. - 7:00 p.m.</span>
              </li>
            </ul>
            <a href="#contacto" className="inline-block text-center px-10 py-4 rounded-full font-bold bg-gradient-to-r from-[#00D4FF] to-[#0080FF] text-nova-bg shadow-[0_0_20px_rgba(0,212,255,0.4)] hover:shadow-[0_0_30px_rgba(0,212,255,0.7)] hover:scale-105 transition-all duration-300" data-id="element-186">
              ESCRÍBENOS AHORA
            </a>
          </div>
        </div>

        <div className="border-t border-nova-card pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-187">
          <p className="text-nova-text-muted text-sm text-center md:text-left" data-id="element-188">
            © 2026 NovaWeb. Todos los derechos reservados.
          </p>
          <div className="flex gap-4 text-sm text-nova-text-muted" data-id="element-189">
            <button type="button" onClick={() => window.dispatchEvent(new CustomEvent('nova-navigate', {
            detail: 'privacy'
          }))} className="hover:text-nova-accent transition-colors" data-id="element-190">
              Política de Privacidad
            </button>
            <span data-id="element-191">|</span>
            <button type="button" onClick={() => window.dispatchEvent(new CustomEvent('nova-navigate', {
            detail: 'terms'
          }))} className="hover:text-nova-accent transition-colors" data-id="element-192">
              Términos de Servicio
            </button>
          </div>
        </div>
      </div>
    </footer>;
}